import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyStudyConclusionApiService } from './company-study-conclusion-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyStudyConclusionApiService extends GeneratedCompanyStudyConclusionApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
